import * as sharedApi from '../../../utils/api/collections';
import { PrivacyType } from '../../../types/privacyType';

export const COLLECTIONS_ACTIONS = {
    UPDATE: 'update_collection',
    CREATE: 'create_collection',
    SET_ALL: 'set_all_collections',
};

export const updateCollection = (api, params) => async (dispatch) => {
    const collection = await api.updateCollection(params);

    dispatch({
        type: COLLECTIONS_ACTIONS.UPDATE,
        data: { collection },
    });

    return collection;
};

export const fetchAllCollections = (params) => async (dispatch) => {
    try {
        const collections = await sharedApi.fetchAllCollections(params);

        dispatch(setAllCollections(collections));
        // eslint-disable-next-line no-empty
    } catch (ignore) {}
};

export const setAllCollections = (collections) => ({
    type: COLLECTIONS_ACTIONS.SET_ALL,
    data: { collections },
});

export const shareWithTeam = (api, params, creator) => async (dispatch) => {
    const collection = await api.shareWithTeam(params);

    const dispatchProps = params.shouldCopy
        ? { type: COLLECTIONS_ACTIONS.CREATE, collection: { ...collection, creator } }
        : { type: COLLECTIONS_ACTIONS.UPDATE, collection };

    dispatch({
        type: dispatchProps.type,
        data: {
            collection: dispatchProps.collection,
        },
    });

    return collection;
};

export const socialShareCollection = (api, params) => async (dispatch) => {
    const collection = await api.updateCollection({
        ...params,
        privacyType: PrivacyType.PUBLIC,
    });

    dispatch({
        type: COLLECTIONS_ACTIONS.UPDATE,
        data: { collection },
    });

    return collection;
};
